import { useEffect, useState } from 'react';
import { authService } from './auth-service';

const useIsAuthenticated = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(null);
  useEffect(() => {
    authService
      .isAuthenticated()
      .then(authenticated => setIsAuthenticated(authenticated));
  }, []);

  return isAuthenticated;
};

export default useIsAuthenticated;
